import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Row, Col, Button, Card, Table, Badge } from "react-bootstrap";
import Layout from "../../layout/Layout";
import Fancybox from "../../Component/FancyBox";
import { API } from "../../App";
import Cookies from "js-cookie";

const DashboradWidgetsView = () => {
  const { id } = useParams();
  const [loading, Setloading] = useState(false);
  const [user, setuser] = useState({
    rank: "",
    category_id: "",
    dashboard_theme_id: "",
    widget_name: "",
    is_premium: "",
    status: "",
    created_at: "",
    updated_at: "",
  });
  const [variants, setVariants] = useState([]);
  const [icons, setIcons] = useState([]);
  let navigate = useNavigate();

  const formatDate = (value) => {
    if (!value) return "-";
    const ms = Number(value);
    const d = new Date(isNaN(ms) ? value : ms);
    if (isNaN(d.getTime())) return value;
    return d.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  const loadData = async (_id) => {
    Setloading(true);
    const token = Cookies.get("jwt");
    const viewData = await API.post(
      `/dashboardWidgets/${_id}`,
      {},
      { headers: { authorization: `Bearer ${token}` } },
    );
    const data = viewData.data.data[0];
    setuser({
      rank: data.rank,
      category_id: data.category_id?.name || "",
      dashboard_theme_id: data.dashboard_theme_id?.name || "",
      widget_name: data.widget_name || "",
      is_premium: data.is_premium,
      status: data.status,
      created_at: data.created_at,
      updated_at: data.updated_at,
    });
    setVariants(
      (data.variants || [])
        .slice()
        .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0)),
    );
    setIcons(data.dashboard_widget_data || []);
    Setloading(false);
  };

  useEffect(() => {
    loadData(id);
  }, []);

  return (
    <Layout sidebar={true}>
      <div div className="page-heading">
        <h3>
          <Link to="/dashbordwidgets" className="btn btn-primary btn-icon me-3">
            <i className="bx bxs-left-arrow-alt"></i>
          </Link>
          View Dashboard Widgets -{" "}
          <span>{user.widget_name || user.category_id}</span>
        </h3>
        <Row className="align-items-center">
          <Col md="auto" xs={6}>
            <Link to={`/dashbordwidgets/edit/${id}`}>
              <Button variant="primary" value="edit">
                Edit
              </Button>
            </Link>
          </Col>
        </Row>
      </div>
      <div className="page-content">
        <Card>
          <Card.Body>
            {loading ? <div className="loader table-loader"></div> : <></>}
            <Fancybox>
              <Row>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">New Index</p>{" "}
                    <span>{user.rank}</span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Category Id</p>{" "}
                    <span>{user.category_id}</span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Widget Name</p>{" "}
                    <span>{user.widget_name || "-"}</span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Theme</p>{" "}
                    <span>{user.dashboard_theme_id || "-"}</span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Status</p>{" "}
                    <span>{user.status === true ? "true" : "false"}</span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Premium</p>{" "}
                    <span>{user.is_premium === true ? "true" : "false"}</span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Created At</p>{" "}
                    <span>{formatDate(user.created_at)}</span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Updated At</p>{" "}
                    <span>{formatDate(user.updated_at)}</span>
                  </div>
                </Col>
              </Row>

              <hr />
              <h5 className="mb-3">Widget Sizes (Variants)</h5>
              {variants.length === 0 ? (
                <p className="text-muted">No sizes added.</p>
              ) : (
                <Table bordered responsive className="align-middle">
                  <thead>
                    <tr>
                      <th>Size</th>
                      <th className="text-center">Preview Image</th>
                      <th className="text-center">Widget Image</th>
                      <th className="text-center">Clock Image</th>
                      <th>Text Color</th>
                      <th>Font Name</th>
                      <th>Alignment</th>
                      <th>Quote</th>
                      <th className="text-center">Sort</th>
                      <th className="text-center">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {variants.map((v, ind) => (
                      <tr key={v._id || ind}>
                        <td className="text-capitalize">{v.widget_type}</td>
                        <td className="text-center">
                          {v.preview_image ? (
                            <a data-fancybox="gallery" href={v.preview_image}>
                              <img
                                src={v.preview_image}
                                className="hv-40 bg-light rounded-3"
                                alt="preview"
                              />
                            </a>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td className="text-center">
                          {v.widget_image ? (
                            <a data-fancybox="gallery" href={v.widget_image}>
                              <img
                                src={v.widget_image}
                                className="hv-40 bg-light rounded-3"
                                alt="widget"
                              />
                            </a>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td className="text-center">
                          {v.clock_image ? (
                            <a data-fancybox="gallery" href={v.clock_image}>
                              <img
                                src={v.clock_image}
                                className="hv-40 bg-light rounded-3"
                                alt="clock"
                              />
                            </a>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td>{v.text_color || "-"}</td>
                        <td>{v.font_name || "-"}</td>
                        <td className="text-capitalize">
                          {v.alignment || "-"}
                        </td>
                        <td>{v.quote || "-"}</td>
                        <td className="text-center">{v.sort_order}</td>
                        <td className="text-center">
                          <Badge bg={v.status ? "success" : "secondary"}>
                            {v.status ? "ON" : "OFF"}
                          </Badge>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}

              {icons.length > 0 && (
                <>
                  <hr />
                  <h5 className="mb-3">Icons (Color / Font)</h5>
                  <Table bordered responsive className="align-middle">
                    <thead>
                      <tr>
                        <th>Color Name</th>
                        <th>Font Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {icons.map((ic, ind) => (
                        <tr key={ic._id || ind}>
                          <td>{ic.color_name || "-"}</td>
                          <td>{ic.font_name || "-"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </>
              )}
            </Fancybox>
          </Card.Body>
        </Card>
      </div>
    </Layout>
  );
};

export default DashboradWidgetsView;
